import type { ScopesRef } from "./ScopesRef";

export enum Scope {
  ADMIN = "ADMIN",
  PERMISSION_ESCALATE = "PERMISSION_ESCALATE",
  PERSONS = "PERSONS",
  REFUNDS = "REFUNDS",
  REPORTING = "REPORTING",
  USERS = "USERS",
}

export const ScopeRowId: Record<Scope, string> = {
  [Scope.ADMIN]: "admin",
  [Scope.PERMISSION_ESCALATE]: "permissions:escalate",
  [Scope.PERSONS]: "persons",
  [Scope.REFUNDS]: "refunds",
  [Scope.REPORTING]: "reporting",
  [Scope.USERS]: "users",
};

export const ScopeFromRowId = (rowId: string): Scope | undefined =>
  (Object.keys(ScopeRowId) as Scope[]).find(
    (key) => ScopeRowId[key] === rowId,
  );

export const ScopeToRef = (key: Scope): ScopesRef => ({
  scopeId: ScopeRowId[key],
});
